import api from '../../api/axios';
import { showError, showSuccess } from '../../Components/reuse/Toast';

// Action Types: Get Default Prompt
export const GET_DEFAULT_PROMPT_REQUEST = 'GET_DEFAULT_PROMPT_REQUEST';
export const GET_DEFAULT_PROMPT_SUCCESS = 'GET_DEFAULT_PROMPT_SUCCESS';
export const GET_DEFAULT_PROMPT_FAILURE = 'GET_DEFAULT_PROMPT_FAILURE';

// Action Types: Change Default Agent Prompt
export const CHANGE_DEFAULT_AGENT_PROMPT_REQUEST = 'CHANGE_DEFAULT_AGENT_PROMPT_REQUEST';
export const CHANGE_DEFAULT_AGENT_PROMPT_SUCCESS = 'CHANGE_DEFAULT_AGENT_PROMPT_SUCCESS';
export const CHANGE_DEFAULT_AGENT_PROMPT_FAILURE = 'CHANGE_DEFAULT_AGENT_PROMPT_FAILURE';

// Action Types: Global Prompt Settings
export const SAVE_GLOBAL_PROMPT_REQUEST = 'SAVE_GLOBAL_PROMPT_REQUEST';
export const SAVE_GLOBAL_PROMPT_SUCCESS = 'SAVE_GLOBAL_PROMPT_SUCCESS';
export const SAVE_GLOBAL_PROMPT_FAILURE = 'SAVE_GLOBAL_PROMPT_FAILURE';

export const getDefaultPrompt = () => async (dispatch) => {
  dispatch({ type: GET_DEFAULT_PROMPT_REQUEST });
  try {
    const response = await api.get('agent/getDefaultPrompt');
    const success = response?.data?.success === undefined ? true : response.data.success;
    if (success) {
      dispatch({ type: GET_DEFAULT_PROMPT_SUCCESS, payload: response.data });
      return { success: true, data: response.data };
    }
    const message = response?.data?.message || 'Failed to fetch default prompt';
    dispatch({ type: GET_DEFAULT_PROMPT_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to fetch default prompt';
    dispatch({ type: GET_DEFAULT_PROMPT_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  }
};

export const changeDefaultAgentPrompt = (prompt, userIds = [], type = 'simpleprompt') => async (dispatch) => {
  dispatch({ type: CHANGE_DEFAULT_AGENT_PROMPT_REQUEST });
  try {
    const response = await api.post('agent/changeDefaultAgentPrompt', { prompt, userIds, type });
    const success = response?.data?.success === undefined ? true : response.data.success;
    if (success) {
      dispatch({ type: CHANGE_DEFAULT_AGENT_PROMPT_SUCCESS, payload: response.data });
      if (response?.data?.message) {
        showSuccess(response.data.message);
      }
      return { success: true, data: response.data };
    }
    const message = response?.data?.message || 'Failed to save default prompt';
    dispatch({ type: CHANGE_DEFAULT_AGENT_PROMPT_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to save default prompt';
    dispatch({ type: CHANGE_DEFAULT_AGENT_PROMPT_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  }
};

export const saveGlobalPrompt = (prompt, type = 'simpleprompt') => async (dispatch) => {
  dispatch({ type: SAVE_GLOBAL_PROMPT_REQUEST });
  try {
    const response = await api.post('agent/globalPromptSettings', { prompt, type });
    const success = response?.data?.success === undefined ? true : response.data.success;
    if (success) {
      dispatch({ type: SAVE_GLOBAL_PROMPT_SUCCESS, payload: response.data });
      if (response?.data?.message) {
        showSuccess(response.data.message);
      }
      return { success: true, data: response.data };
    }
    const message = response?.data?.message || 'Failed to save global prompt';
    dispatch({ type: SAVE_GLOBAL_PROMPT_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to save global prompt';
    dispatch({ type: SAVE_GLOBAL_PROMPT_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  }
};
